import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button } from '@material-ui/core';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import React, { useContext } from 'react';
import { ServicoContext } from '../../ServicoContext';
import { servicoModais } from '../modal/servicoModais';
import { ServicoSearchStyles } from './styles';

const ServicoSearchHeader = () => {
  const [, setSearch] = useContext(ServicoContext).search;
  const [, setModal] = useContext(ServicoContext).modal;

  const styles = ServicoSearchStyles();

  const handleChange = (value) => {
    setSearch(value);
  };

  const handleOpenBuscaAvancada = () => {
    setModal(servicoModais.buscaAvancada);
  };

  return (
    <PageHeader title="Serviços" icon={<ServicoIcon />}>
      <div className={styles.searchHeaderServico}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar onChange={handleChange} />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default ServicoSearchHeader;
